import { cn } from "@/lib/utils";

export function RateLimitBadge({ remaining }: { remaining: number }) {
  const low = remaining <= 5;
  return (
    <span className={cn(low ? "text-warn" : "text-ink-3")}>
      лимит GitHub: {remaining}
    </span>
  );
}
